import { storeToRefs } from "pinia";

import { useLayoutStore } from "@/stores/layout/layout-store";

export function useLayout() {
  const layoutStore = useLayoutStore();
  const { isGlobalLoading } = storeToRefs(layoutStore);

  return { isGlobalLoading };
}
